module.exports = __webpack_public_path__ + "static/oof_final-02-39c3c72048861cf6f59e51ee96de6a70.png";